import React, { useState } from 'react'
import { AnimatePresence } from "motion/react"
import * as motion from "motion/react-client"
import { Img } from 'styles/GlobalStyle'
import { MicSettingsAllow } from 'assets'
import { PermissionBlockedStyles } from '../Style'

//לינק להגדרות לאפשור המיקרופון 
const settingsUrl = `chrome://settings/content/siteDetails?site=${encodeURIComponent(window.location.origin)}`

const texts = {
    teacher: {
        step1Before: "לחצי על ",
        step1After: " והדביקי אותו בשורת הכתובת בדפדפן",
        step2: "בשורת \"מיקרופון\", שני את ההגדרה ל\"זה בסדר\"",
        step3: "חזרי לכאן ולחצי על הכפתור למטה"
    },
    child: {
        step1Before: "לחצו על ",
        step1After: " והדביקו אותו בשורת הכתובת בדפדפן",
        step2: "בשורת \"מיקרופון\", שנו את ההגדרה ל\"זה בסדר\"",
        step3: "חזרו לכאן ולחצו על הכפתור למטה"
    }
}

// מסך שמופיע כשלחצו על "בדיקה חוזרת" והמיקרופון עדיין חסום
const PermissionBlocked = (props) => {
    const { checkAgain, isTeacherCheck } = props
    const t = isTeacherCheck ? texts.teacher : texts.child

    const [copied, setCopied] = useState(false)
    const [copyFailed, setCopyFailed] = useState(false)

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(settingsUrl)
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        } catch (e) {
            setCopyFailed(true) // אם ההעתקה נכשלה מציגים את הכתובת כדי שיעתיקו ידנית
        }
    }

    return (
        <AnimatePresence>
            <motion.div
                exit={{ opacity: 0 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.7 }}
                key="permission-blocked"
            >
                <PermissionBlockedStyles>
                    <div className='pb-texts'>
                        <div className='pb-title'>{"צריך לאפשר גישה למיקרופון"}</div>
                        <div className='pb-step'>{"כדי לבדוק את השמע, הדפדפן צריך את האישור שלך להשתמש במיקרופון."}</div>
                        <div className='pb-step'>
                            {"1. "}{t.step1Before}
                            <span className='pb-copy-link' onClick={copyLink}>
                                {copied ? "הקישור הועתק!" : "\"העתקת קישור להגדרות\""}
                            </span>
                            {t.step1After}
                        </div>
                        {copyFailed && <div className='pb-url'>{settingsUrl}</div>}
                        <div className='pb-step'>{"2. "}{t.step2}</div>
                    </div>
                    <div className='pb-img-wrap'>
                        <Img className='pb-img' src={MicSettingsAllow} />
                        <svg className='pb-highlight' width="177" height="46" viewBox="0 0 177 46" fill="none">
                            <path d="M88.5 1.5C112.849 1.5 134.841 4.06671 150.701 8.18848C158.642 10.2523 164.962 12.6844 169.26 15.3252C173.642 18.0181 175.5 20.6537 175.5 23C175.5 25.3463 173.642 27.9819 169.26 30.6748C164.962 33.3156 158.642 35.7477 150.701 37.8115C134.841 41.9333 112.849 44.5 88.5 44.5C64.1509 44.5 42.1589 41.9333 26.2988 37.8115C18.3577 35.7477 12.0382 33.3156 7.74023 30.6748C3.35759 27.9819 1.5 25.3463 1.5 23C1.5 20.6537 3.35759 18.0181 7.74023 15.3252C12.0382 12.6844 18.3577 10.2523 26.2988 8.18848C42.1589 4.06671 64.1509 1.5 88.5 1.5Z" stroke="#FF0000" strokeWidth="3" />
                        </svg>
                    </div>
                    <div className='pb-step'>{"3. "}{t.step3}</div>
                    <div className='pb-button' onClick={checkAgain}>
                        <i className="fa-regular fa-check"></i>
                        {"סיימתי, חזרה לבדיקה"}
                    </div>
                </PermissionBlockedStyles>
            </motion.div>
        </AnimatePresence>
    )
}

export default PermissionBlocked
